export default {
    hide: () => {},
    getVisibilityStatus: () => Promise.resolve('hidden'),
};
